export const categoryClassMap = {
  "Promo Aktion": "badge-category-promo-aktion",
  "Junge Leute": "badge-category-junge-leute",
  "Ohne Rabatt": "badge-category-ohne-rabatt",
  "60+ Vorteil": "badge-category-60plus",
  SOHO: "badge-category-business",
  "O2 Blue": "badge-category-blue",
  "Internet & Festnetz": "badge-category-internet-festnetz",
  "VDSL": "badge-category-vdsl",
  "Kabel": "badge-category-kabel",
  "Glasfaser": "badge-category-glasfaser",
  "Home Spot": "badge-category-home-spot",
  "O2 Mobile": "badge-category-o2-mobile",
  "O2 Mobile Unlimited": "badge-category-unlimited",
  "O2 Home": "badge-category-o2-home",
  "Zusatzoptionen": "badge-category-zusatz",
  "O2 Business": "badge-category-business",
};
